export function formatAddress(data) {
    return (
        `${data.address1}, ${data.address2 ? data.address2 + ', ' : ''}` +
        `${data.postcode} ${data.city}, ` +
        `${data.region ? data.region + ', ' : ''}` +
        `${data.country && data.country.toUpperCase()}`
    );
}